import CarPageContent from '@features/market/car/Car.PageContent';

export default function CarAddPage() {
    return <CarPageContent />;
}
